import { MwLoadOptions } from 'app/models/load-options.model';
import {
  SupplierApiModel,
  SuppliersResponseModel,
} from 'app/models/suppliers.model';
import { createAction, props } from '@ngrx/store';

export const loadSuppliers = createAction(
  '[Suppliers] Load',
  props<{ loadOptions?: MwLoadOptions }>()
);

export const loadSuppliersSuccess = createAction(
  '[Suppliers] Load Successful',
  props<{ response: SuppliersResponseModel }>()
);

export const loadSuppliersFailure = createAction(
  '[Suppliers] Load Failure',
  props<{ error: any }>()
);

export const createSupplier = createAction(
  '[Suppliers] Create',
  props<{ supplier: SupplierApiModel }>()
);

export const createSupplierSuccess = createAction(
  '[Suppliers] Create Successful'
);

export const createSupplierFailure = createAction(
  '[Suppliers] Create Failure',
  props<{ error: any }>()
);

export const updateSupplier = createAction(
  '[Suppliers] Update',
  props<{ supplier: SupplierApiModel }>()
);

export const updateSupplierSuccess = createAction(
  '[Suppliers] Update Successful'
);

export const updateSupplierFailure = createAction(
  '[Suppliers] Update Failure',
  props<{ error: any }>()
);

export const deleteSupplier = createAction(
  '[Suppliers] Delete',
  props<{ supplier: SupplierApiModel }>()
);

export const deleteSupplierSuccess = createAction(
  '[Suppliers] Delete Successful'
);

export const deleteSupplierFailure = createAction(
  '[Suppliers] Delete Failure',
  props<{ error: any }>()
);
